import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import ReactDynamicTable from "../ReactDynamicTable/ReactDynamicTable";

const VGMModal = ({ vgmDetails, titleHeading, modalOpen, setModalOpen }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, [modalOpen]);

  const handleClose = () => {
    setShow(false);
    setModalOpen(false);
  };
  return (
    <>
      <Modal show={show} onHide={handleClose} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title
            style={{ textTransform: "capitalize" }}
          >{`${titleHeading} Details`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-data">
            <ReactDynamicTable data={vgmDetails} />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VGMModal;
